var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "sailing-version"
  }, [_c("section", {
    staticClass: "sailing-version__banner-wrapper"
  }, [_c("Banner", {
    attrs: {
      title: "PC远航版",
      description: "远航版主打年轻人群及新生代股民，拥有扁平化、全新高DPI界面、运行更快、更节省内存等优势，用户体验更好。",
      productId: _vm.productId
    }
  })], 1), _c("section", {
    staticClass: "advantages"
  }, [_c("div", {
    staticClass: "advantages-main"
  }, [_c("Title", {
    attrs: {
      title: "产品优势"
    }
  }), _c("Advantages", {
    attrs: {
      leftItems: _vm.leftItems,
      rightItems: _vm.rightItems
    }
  })], 1)]), _c("section", {
    staticClass: "adcantage-features"
  }, [_c("div", {
    staticClass: "adcantage-features-main"
  }, [_c("Title", {
    attrs: {
      title: "产品特色"
    }
  })], 1), _c("section", {
    staticClass: "adcantage-features-img"
  }, [_c("img", {
    attrs: {
      src: _vm.imgSrc,
      alt: ""
    }
  })]), _c("div", {
    staticClass: "adcantage-features-main"
  }, [_c("section", {
    staticClass: "adcantage-features-card"
  }, [_c("AdcantageFeatures", {
    attrs: {
      list: _vm.adcantageFeaturesList
    }
  })], 1)])]), _c("section", {
    staticClass: "securities"
  }, [_c("Securities")], 1), _c("Appointment2")], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };